import { render, staticRenderFns } from "./Dialogue.vue?vue&type=template&id=1f008c8c&scoped=true"
import script from "./Dialogue.vue?vue&type=script&lang=js"
export * from "./Dialogue.vue?vue&type=script&lang=js"
import style0 from "./Dialogue.vue?vue&type=style&index=0&id=1f008c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f008c8c",
  null
  
)

export default component.exports